var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1572 3.94305C20.0239 3.94643 19.8838 3.96337 19.7471 3.99725L5.52832 7.71043C4.37988 8.00857 3.55957 9.05206 3.55957 10.2311V22.1566C3.55957 23.5829 4.74561 24.7585 6.18457 24.7585H21.9346C23.3735 24.7585 24.5596 23.5829 24.5596 22.1566V10.8815C24.5596 9.45522 23.3735 8.27961 21.9346 8.27961H10.2314L20.1846 5.67767V7.4123H21.9346V5.67767C21.9346 4.70195 21.0972 3.92949 20.1572 3.94305ZM6.18457 10.0142H21.9346C22.4302 10.0142 22.8096 10.3903 22.8096 10.8815V22.1566C22.8096 22.6479 22.4302 23.0239 21.9346 23.0239H6.18457C5.68897 23.0239 5.30957 22.6479 5.30957 22.1566V10.8815C5.30957 10.3903 5.68897 10.0142 6.18457 10.0142ZM19.7471 15.2181C19.0225 15.2181 18.4346 15.8008 18.4346 16.5191C18.4346 17.2373 19.0225 17.82 19.7471 17.82C20.4717 17.82 21.0596 17.2373 21.0596 16.5191C21.0596 15.8008 20.4717 15.2181 19.7471 15.2181Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletblack);
export default __webpack_public_path__ + "static/media/walletblack.236fe416e014391dc6935693391ee46c.svg";
export { ForwardRef as ReactComponent };